import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    DialogActions,
    DialogContent, Grid,
    TextField,
} from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { CarModel } from 'models/StockModel';


const noteNames = [
    'yard_note',
    'yard_cargo',
    'yard_problems',
    'vessel_note',
    'destination_note',
    'destination_problems',
];

type NotesDialogProps = {
    car: CarModel,
} & ModalActionProps<{[name: string]: string}>;

const NotesDialog = ({car, onFinish}: NotesDialogProps) => {
    const {t} = useTranslation('cars');

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        // @ts-ignore
        onFinish(Object.fromEntries(new FormData(event.currentTarget).entries()));
    };

    const notes = [
        {
            name: 'note',
            value: car.note,
        }
    ];

    for (const noteName of noteNames) {
        notes.push({
            name: noteName,
            value: car.albums.find(a => a.name === noteName)?.note!,
        });
    }

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextField
                            id="yard_key"
                            name="yard_key"
                            label={t('yard_key')}
                            defaultValue={car.yard?.key}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="yard_location"
                            name="yard_location"
                            label={t('yard_location')}
                            defaultValue={car.yard?.location}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                {notes.map(n => (
                    <TextField
                        key={n.name}
                        fullWidth
                        multiline
                        rows={n.name === 'note' ? 5 : 2}
                        label={n.name.split('_').join(' ')}
                        name={n.name}
                        defaultValue={n.value}
                    />
                ))}
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('apply')}</Button>
            </DialogActions>
        </Box>
    );
};

export default NotesDialog;
